import React from "react";
import {Checkbox} from "antd";
import StyleColourPicker from "./StyleColourPicker";
import StyleBorders from "./StyleBorders";
import {
    manageColours,
    getColourOnColour,
    getRGBFromRGBA,
    ensureColourContrast,
    getDefaultColour
} from "./ManageColours";

const CustomBlockStyles = props => {
    const {styles, variant, updateStylesCallback} = props;
    const CORE_COLOURS = {
        MAIN: 'main',
        ON_MAIN: 'onMain',
        BG: 'bg',
        ON_BG: 'on_bg'
    }
    const generateColours = (mainColour) => ({
        [CORE_COLOURS.ON_MAIN]: getColourOnColour(mainColour),
        [CORE_COLOURS.BG]: getRGBFromRGBA(mainColour, .1),
        [CORE_COLOURS.ON_BG]: ensureColourContrast(mainColour, getRGBFromRGBA(mainColour, .1))
    });
    const {colours, updateColours, toggleGeneratedColours} = manageColours(
        styles,
        {
            [CORE_COLOURS.MAIN]: {name: `--cont-block-${variant}-colour`, mainColour: true},
            [CORE_COLOURS.ON_MAIN]: {name: `--cont-on-block-${variant}-colour`, autoGenerated: true},
            [CORE_COLOURS.BG]: {name: `--cont-block-${variant}-bg`, autoGenerated: true},
            [CORE_COLOURS.ON_BG]: {name: `--cont-on-block-${variant}-bg`, autoGenerated: true}
        },
        generateColours,
        updateStylesCallback
    );

    return (
        <>
            <h4 className="margin-t--m">Colours</h4>
            <div className="flexAlignCentre margin-t--s">
                <div className="flexMax">
                    Block
                </div>
                <div className="flex">
                    <StyleColourPicker
                        defaultValue={getDefaultColour(`--cont-block-${variant}-colour`, styles)}
                        onChange={(colour) => {
                            updateColours(CORE_COLOURS.MAIN, {
                                [`--cont-block-${variant}-colour`]: colour.hex(),
                                [`--cont-block-${variant}-colour-RGB`]: colour.rgb().array()
                            });
                        }}
                    />
                </div>
            </div>
            <Checkbox
                indeterminate={(
                    (colours[CORE_COLOURS.ON_MAIN].autoGenerated ||
                        colours[CORE_COLOURS.BG].autoGenerated ||
                        colours[CORE_COLOURS.ON_BG].autoGenerated) &&
                    !(colours[CORE_COLOURS.ON_MAIN].autoGenerated &&
                        colours[CORE_COLOURS.BG].autoGenerated &&
                        colours[CORE_COLOURS.ON_BG].autoGenerated)
                )}
                checked={(
                    colours[CORE_COLOURS.ON_MAIN].autoGenerated == true &&
                    colours[CORE_COLOURS.BG].autoGenerated == true &&
                    colours[CORE_COLOURS.ON_BG].autoGenerated == true
                )}
                onChange={(event) => toggleGeneratedColours(event.target.checked)}
            >
                Auto generated colours
            </Checkbox>
            <p className="ch-text-small margin-t--s">* Color can be auto-generated based on main color.</p>
            <div className="flexAlignCentre margin-t--s">
                <div className="flexMax">
                    On block{colours[CORE_COLOURS.ON_MAIN].autoGenerated ? " (auto)" : ""}*
                </div>
                <div className="flex">
                    <StyleColourPicker
                        defaultValue={getDefaultColour(`--cont-on-block-${variant}-colour`, styles)}
                        onChange={(colour) => updateColours(CORE_COLOURS.ON_MAIN, {
                            [`--cont-on-block-${variant}-colour`]: colour.rgb().string()
                        })}
                    />
                </div>
            </div>
            <div className="flexAlignCentre margin-t--s">
                <div className="flexMax">
                    Background{colours[CORE_COLOURS.BG].autoGenerated ? " (auto)" : ""}*
                </div>
                <div className="flex">
                    <StyleColourPicker
                        defaultValue={getDefaultColour(`--cont-block-${variant}-bg`, styles)}
                        onChange={(colour) => updateColours(CORE_COLOURS.BG, {
                            [`--cont-block-${variant}-bg`]: colour.rgb().string()
                        })}
                    />
                </div>
            </div>
            <div className="flexAlignCentre margin-t--s">
                <div className="flexMax">
                    On background{colours[CORE_COLOURS.ON_BG].autoGenerated ? " (auto)" : ""}*
                </div>
                <div className="flex">
                    <StyleColourPicker
                        defaultValue={getDefaultColour(`--cont-on-block-${variant}-bg`, styles)}
                        onChange={(colour) => updateColours(CORE_COLOURS.ON_BG, {
                            [`--cont-on-block-${variant}-bg`]: colour.hsl().string()
                        })}
                    />
                </div>
            </div>
            {/*<StyleBorders*/}
            {/*    defaultValues={{*/}
            {/*        border: {*/}
            {/*            [`--block-border-width`]: styles[`--block-border-width`],*/}
            {/*            [`--block-border-colour`]: styles[`--block-border-colour`]*/}
            {/*        },*/}
            {/*        radius: {*/}
            {/*            [`--block-border-radius-tl`]: styles[`--block-border-radius-tl`],*/}
            {/*            [`--block-border-radius-tr`]: styles[`--block-border-radius-tr`],*/}
            {/*            [`--block-border-radius-bl`]: styles[`--block-border-radius-bl`],*/}
            {/*            [`--block-border-radius-br`]: styles[`--block-border-radius-br`]*/}
            {/*        }*/}
            {/*    }}*/}
            {/*    onChange={updateStylesCallback}*/}
            {/*/>*/}
        </>
    )
}

export default CustomBlockStyles;